import { render } from "./icon-gr-list.svg?vue&type=template&id=24fcb88e?inline"
const script = {}
script.render = render

export default script